import { ROUTES } from '@cp/core/routing/constants';
import {
  clearRedirectTarget,
  isSafeRedirectPath,
  REDIRECT_TO_PARAM,
  REDIRECT_TO_STORAGE_KEY,
  stashRedirectTarget,
} from '@/utils/helpers/auth-redirect.helpers';

// Pages of the sign-in flow itself: never a target, and landing on one keeps the pending target.
const SIGN_IN_FLOW_PATHS: string[] = [
  ROUTES.SIGN_IN.ROOT,
  ROUTES.PASSWORD_RESET.ROOT,
  ROUTES.ORGANIZATION_SELECTION,
  ROUTES.ACCOUNT_ACTIVATION,
  ROUTES.ORGANIZATION_REMOVED,
];

const getPathname = (target: string): string => new URL(target, globalThis.location.origin).pathname;

const isSignInFlowPath = (pathname: string): boolean => SIGN_IN_FLOW_PATHS.some((path) => pathname.startsWith(path));

export const rememberRedirectTarget = (pathname: string, search: string): void => {
  if (pathname.startsWith(ROUTES.SIGN_IN.ROOT)) {
    // The shared API client sends an expired session to /sign-in?redirectTo=<page>.
    const fromQuery = new URLSearchParams(search).get(REDIRECT_TO_PARAM);
    if (isSafeRedirectPath(fromQuery) && !isSignInFlowPath(getPathname(fromQuery))) {
      stashRedirectTarget(fromQuery);
    }
    return;
  }

  if (isSignInFlowPath(pathname)) return;
  stashRedirectTarget(`${pathname}${search}`);
};

// Read without clearing: several sign-in steps land the user, and each must see the same target.
export const getRedirectTarget = (): string | null => {
  const target = sessionStorage.getItem(REDIRECT_TO_STORAGE_KEY);
  return isSafeRedirectPath(target) ? target : null;
};

export const getPostSignInPath = (): string => getRedirectTarget() ?? ROUTES.HOME;

export const getRedirectTargetEntityId = (): string | undefined => {
  const target = getRedirectTarget();
  if (!target) return undefined;

  const [root, entityId] = getPathname(target).split('/').filter(Boolean);
  return `/${root}` === ROUTES.ENTITY.ROOT ? entityId : undefined;
};

export const clearRedirectTargetOnArrival = (pathname: string): void => {
  const target = getRedirectTarget();
  if (target && getPathname(target) === pathname) {
    clearRedirectTarget();
  }
};
